import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { StickyContainer } from '@sparefoot/react-core';

import { Container } from 'components/core/Page';
import { Paragraph, H2 } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';

import './StickySearch.scss';

export default function StickySearch({ hidden, onSearch, location, sticky, horizontal }) {
	return React.createElement(
		sticky ? StickyContainer : Fragment,
		sticky ? ({ collapse: hidden }) : undefined,
		<div className={classnames('sticky-search', { hidden }, { horizontal })}>
			<Container>
				{horizontal ? (
					<H2 color="white" size="medium" weight="bold" last className="title">Find Self Storage Near You</H2>
				) : (
					<Paragraph
						color="white"
						className="search-text"
					>
						Search for other storage facilities near this one.
					</Paragraph>
				)}
				<SearchBox
					darkButton
					onSearch={onSearch}
					location={location}
					segmentPrefix="sticky search box"
					id="sticky-search"
					useBrowserLocation
				/>
			</Container>
		</div>
	);
}

StickySearch.propTypes = {
	hidden: PropTypes.bool,
	sticky: PropTypes.bool,
	onSearch: PropTypes.func.isRequired,
	location: PropTypes.string,
	horizontal: PropTypes.bool
};

StickySearch.defaultProps = {
	sticky: true
};
